<template>
  <div class="p-2 container-fluid">
    <div
      class="d-flex justify-content-start align-items-center bannerMobile mb-2"
    >
      <img :src="logoWhite" class="avatar logoMoble" alt="main_logo" />
    </div>
    <div class="row form-row">
      <div class="col-sm-12">
        <div class="card">
          <!--Informacion personal-->
          <div class="card-header p-2">
            <div
              class="row form-row list-group-item border-0 d-flex p-3 mb-2 bg-gray-100 border-radius-lg w-100 d-flex justify-content-center"
            >
              <p class="text-mb">
                <strong>1) </strong>Ingrese su número de cédula:<strong
                  class="text-danger ms-1"
                  >*</strong
                >
              </p>

              <div ref="nextSection" class="col-lg-8 col-md-12 col-12">
                <ul class="list-group">
                  <li
                    class="list-group-item border-0 d-flex p-0 mb-3 bg-gray-100 border-radius-lg w-100"
                  >
                    <div class="d-flex flex-column w-100">
                      <div class="row form-row">
                        <!-- Cedula -->
                        <div class="col-md-6 col-12">
                          <h6 class="mb-3 mt-3 text-sm">
                            <i class="fas fa-id-card me-2"></i> Número de
                            Cédula:<i
                              v-if="errorMessage2"
                              class="ps-2 fas fa-asterisk text-danger pe-2"
                            ></i>
                            <strong v-if="errorMessage2" class="text-danger"
                              >Requerido</strong
                            >
                          </h6>

                          <div class="form-check form-check-inline w-80 ps-0">
                            <input
                              v-model="cedula"
                              class="form-control text-lg large"
                              :style="
                                errorMessage2
                                  ? 'border-bottom: 3px solid #f5365c;'
                                  : ''
                              "
                              placeholder="# Cédula (ej. 101230507)"
                              type="tel"
                              @input="fetchSuggestions"
                            />
                            <ul v-if="showDropdown" class="dropdown-menu show">
                              <li
                                v-for="user in suggestions"
                                :key="user.cedula"
                                @click="selectUser(user)"
                              >
                                <a v-if="user.cedula" class="dropdown-item"
                                  >{{ user.cedula }} - {{ user.nombre }}
                                  {{ user.primer_apellido }}
                                  {{ user.segundo_apellido }}</a
                                >
                                <a v-else class="dropdown-item"
                                  >No hay coincidencias</a
                                >
                              </li>
                            </ul>
                          </div>
                          <span
                            v-if="contactMethod === 'id'"
                            class="mb-2 text-xs"
                          >
                            <template v-if="isEditing">
                              <input class="form-control" />
                            </template>
                            <span v-if="!isEditing" class="text-dark text-xs">
                              {{ editedUser?.cedula || `No registrado` }}
                            </span>
                          </span>
                        </div>

                        <!-- Nombre -->
                        <div class="col-md-6 col-12">
                          <h6 class="mb-3 mt-4 text-sm">
                            <i class="fas fa-user-alt me-2"></i> Nombre
                            Completo:
                          </h6>
                          <span class="text-sm mb-0">
                            <b>{{ editedUser?.nombre || "" }}</b
                            >&nbsp;
                            <b>{{ editedUser?.primer_apellido || "" }}</b
                            >&nbsp;
                            <b>{{ editedUser?.segundo_apellido || "" }}</b>
                          </span>
                          <hr class="dark mb-4 mt-0 w-80" />
                        </div>
                      </div>
                      <div
                        v-if="alreadyRegistered && cedula"
                        class="row form-row rounded p-3 mx-2 mx-md-5 d-flex justify-content-center"
                        style="background-color: #f8d7da; border-color: #f5c6cb"
                      >
                        <h6 class="mb-1 text-lg text-center">
                          <i
                            class="fas fa-times-circle fa-2x"
                            style="color: #dc3545"
                          ></i>
                        </h6>
                        <p
                          class="text-md text-center mb-0"
                          style="color: #721c24"
                        >
                          <strong>Elector existente:</strong> Este ciudadano ya
                          forma parte de nuestro censo electoral.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="col-lg-3 col-md-6 col-12">
                <!-- Centro de Voto -->
                <div class="timeline timeline-one-side">
                  <div class="timeline-block mb-3">
                    <span class="timeline-step">
                      <i class="fas fa-city text-white"></i>
                    </span>
                    <div class="timeline-content">
                      <h6 class="text-dark text-sm font-weight-bold mb-0">
                        {{ editedUser?.distelec?.provincia || "-" }}
                      </h6>
                      <p
                        class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                      >
                        Provincia
                      </p>
                    </div>
                  </div>
                  <div class="timeline-block mb-3">
                    <span class="timeline-step">
                      <i class="fas fa-building text-white"></i>
                    </span>
                    <div class="timeline-content">
                      <h6 class="text-dark text-sm font-weight-bold mb-0">
                        {{ editedUser?.distelec?.canton || "-" }}
                      </h6>
                      <p
                        class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                      >
                        Cantón
                      </p>
                    </div>
                  </div>
                  <div class="timeline-block mb-0">
                    <span class="timeline-step">
                      <i class="fas fa-home text-white"></i>
                    </span>
                    <div class="timeline-content">
                      <h6 class="text-dark text-sm font-weight-bold mb-0">
                        {{ editedUser?.distelec?.distrito || "-" }}
                      </h6>
                      <p
                        class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                      >
                        Distrito
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                ref="nextSection2"
                class="parent-container col-lg-3 col-md-12 col-12 mt-0 mt-md-0 mt-3 ms-4"
              >
                <div class="timeline timeline-one-side large">
                  <span class="timeline-step large">
                    <i class="fas fa-school text-info pe-1"></i>
                    <i class="fas fa-flag text-danger"></i>
                  </span>
                  <div class="timeline-content ms-6">
                    <h6 class="text-dark text-md font-weight-bold mb-0">
                      {{ editedUser?.junta || "-" }}
                    </h6>
                    <p
                      class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                    >
                      Centro de Votación
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--
          <hr class="horizontal dark my-2" /> -->
          <!--MovimientoS-->
          <!--
            <div class="p-2 card-body">
            <div
              class="row form-row list-group-item border-0 d-flex p-3 mb-2 bg-gray-100 border-radius-lg w-100 d-flex justify-content-center"
            >
              <p class="text-md mb-3">
                <strong>2) </strong>Seleccione el movimiento al que apoya:
              </p>
              <div class="row form-row mb-3 d-flex justify-content-center">
                <div class="col-lg-6 col-md-4 col-6 pe-2">
                  <argon-badge
                    :class="{
                      'selected-badge': selectedBadge === 'Trabajadores',
                    }"
                    size="lg"
                    class="cursor-pointer w-100 h-100 px-4 py-6 badge-hover"
                    @click="selectBadge('Trabajadores')"
                  >
                    Trabajadores
                  </argon-badge>
                </div>
                <div class="col-lg-6 col-md-4 col-6 ps-2">
                  <argon-badge
                    :class="{ 'selected-badge': selectedBadge === 'Mujer' }"
                    size="lg"
                    color="success"
                    class="cursor-pointer w-100 h-100 px-4 py-6 badge-hover"
                    @click="selectBadge('Mujer')"
                  >
                    Mujer
                  </argon-badge>
                </div>
              </div>
              <div class="row form-row mb-3 d-flex justify-content-center">
                <div class="col-lg-6 col-md-4 col-6 pe-2">
                  <argon-badge
                    :class="{ 'selected-badge': selectedBadge === 'Juventud' }"
                    size="lg"
                    color="success"
                    class="cursor-pointer w-100 h-100 px-4 py-6 badge-hover"
                    @click="selectBadge('Juventud')"
                  >
                    Juventud
                  </argon-badge>
                </div>
                <div class="col-lg-6 col-md-4 col-6 ps-2">
                  <argon-badge
                    :class="{
                      'selected-badge': selectedBadge === 'Cooperativo',
                    }"
                    size="lg"
                    color="success"
                    class="cursor-pointer w-100 h-100 px-4 py-6 badge-hover"
                    @click="selectBadge('Cooperativo')"
                  >
                    Cooperativo
                  </argon-badge>
                </div>
              </div>
                <div class="row form-row mb-3 d-flex justify-content-center">

                <div class="col-lg-6 col-md-4 col-6 ps-2 ">
                  <argon-badge
                    :class="{
                      'selected-badge': selectedBadge === 'Municipal',
                    }"
                    size="lg"
                    color="success"
                    class="cursor-pointer w-100 h-100 px-4 py-6 badge-hover"
                    @click="selectBadge('Municipal')"
                  >
                    Municipal
                  </argon-badge>
                </div>
              </div>
            </div>
            -->

          <!--Contacto-->
          <div class="card-header p-2">
            <div
              class="row form-row list-group-item border-0 d-flex p-3 mb-3 mt-0 bg-gray-100 border-radius-lg w-100 d-flex justify-content-center"
            >
              <p class="text-mb">
                <strong>2) </strong>Ingrese un método de contacto:<strong
                  class="text-danger ms-1"
                  >*</strong
                >
              </p>
              <div class="collg-8 col-md-12 col-12">
                <ul class="list-group">
                  <li
                    class="list-group-item border-0 d-flex p-0 mb-3 bg-gray-100 border-radius-lg w-100"
                  >
                    <div class="d-flex flex-column w-100">
                      <div class="row form-row">
                        <!-- Telefono  -->
                        <div class="col-md-6 col-12">
                          <h6 class="mb-3 mt-3 text-sm">
                            <i class="fas fa-phone-square-alt me-2"></i>Número
                            telefónico<i
                              v-if="errorMessagePhone"
                              class="ps-2 fas fa-asterisk text-danger pe-2"
                            ></i>
                            <strong v-if="errorMessagePhone" class="text-danger"
                              >Requerido</strong
                            >
                          </h6>
                          <div
                            class="form-check form-check-inline w-80 ps-0 d-flex"
                          >
                            <input
                              v-model="phone"
                              class="form-control text-lg"
                              :disabled="alreadyRegistered"
                              :style="
                                errorMessagePhone
                                  ? 'border-bottom: 3px solid #f5365c;'
                                  : ''
                              "
                              placeholder="Ej: 88888888"
                              type="tel"
                            />
                          </div>
                        </div>

                        <!-- Email -->
                        <div class="col-md-6 col-12">
                          <h6 class="mb-3 mt-3 text-sm">
                            <i class="fas fa-envelope me-2"></i>Correo
                            Electrónico
                          </h6>
                          <div
                            class="form-check form-check-inline w-80 ps-0 d-flex"
                          >
                            <input
                              v-model="email"
                              class="form-control text-lg"
                              placeholder="Ej: correo@ejemplo.com"
                              type="email"
                              :disabled="alreadyRegistered"
                            />
                          </div>
                        </div>
                        <p
                          v-if="errorMessage"
                          class="text-danger text-md mt-4 mb-1"
                        >
                          {{ errorMessage }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Desea Colaborar en la Campaña 2026 -->
          <div class="card-header p-2">
            <div
              class="row form-row list-group-item border-0 d-flex p-3 mb-3 mt-0 bg-gray-100 border-radius-lg w-100 align-items-center"
            >
              <p class="text-mb mb-2 mb-md-5 me-md-3">
                <strong>3) </strong>Desea Colaborar en la Campaña 2026:<strong
                  class="text-danger ms-1"
                  >*</strong
                >
              </p>

              <div
                class="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 mb-3"
              >
                <select
                  v-model="selectedOption"
                  class="form-select form-select-lg text-lg mb-2 mb-md-0"
                  :style="
                    errorMessageColaboracion ? 'border: 2px solid #f5365c;' : ''
                  "
                  :disabled="alreadyRegistered"
                  style="width: 100%; max-width: 300px"
                >
                  <option disabled value="">Seleccione una opción</option>
                  <option value="Transportes">Transportes</option>
                  <option value="Electorales">Electorales</option>
                  <option value="Alimentacion">Alimentación</option>
                  <option value="Guias">Guías</option>
                  <option value="Movimiento/Sector">
                    Movimiento/Sector
                  </option>
                  <option value="Otro">Otro...</option>
                </select>

                <!-- Input for "Otro" option only -->
                <input
                  v-if="selectedOption === 'Otro'"
                  v-model="otherText"
                  type="text"
                  maxlength="20"
                  placeholder="Otro... (max 20 caracteres)"
                  class="form-control form-control-lg ms-md-2 text-lg ps-3 w-100 w-md-auto"
                  :style="errorMessageOtro ? 'border: 2px solid #f5365c;' : ''"
                  style="min-width: 300px"
                />
                <i
                  v-if="errorMessageColaboracion || errorMessageOtro"
                  class="ps-2 fas fa-asterisk text-danger pe-2"
                ></i>
                <strong v-if="errorMessageColaboracion" class="text-danger"
                  >Requerido</strong
                >
                <strong v-if="errorMessageOtro" class="text-danger ms-1"
                  >Requerido</strong
                >
              </div>
            </div>
          </div>

          <!-- Terminos y Condiciones -->
          <div class="card-header p-2">
            <div
              class="row form-row list-group-item border-0 d-flex p-3 mb-3 mt-0 bg-gray-100 border-radius-lg w-100 align-items-center"
            >
              <div class="text-xs text-center w-100 mb-0" role="alert">
                Al hacer clic en "Confirmar Registro", aceptas automáticamente
                nuestros
                <a
                  href="#"
                  @click.prevent="openTermsModal"
                  class="text-dark font-weight-bold text-decoration-underline"
                  style="cursor: pointer"
                >
                  Términos y Condiciones de Uso y Tratamiento de Datos
                  Personales
                </a>
                <strong class="text-dark ms-1">*</strong>
              </div>
            </div>
          </div>
          <hr class="horizontal dark mt-3 mb-1" />

          <!--Confirmacion -->
          <div
            class="row form-row list-group-item border-0 d-flex p-3 w-100 d-flex justify-content-center"
          >
            <div class="col-lg-8 col-md-12 col-12">
              <argon-button
                class="mt-0 btn-lg py-4 text-lg mb-0"
                color="success"
                full-width
                @click="submitSelection"
                :disabled="alreadyRegistered"
              >
                <i class="fas fa-check pe-2"></i> Confirmar Registro
              </argon-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms and Conditions Modal -->
    <div v-if="isTermsModalOpen" class="modal-overlay" @click="closeTermsModal">
      <div
        class="modal-content card"
        @click.stop
        style="max-width: 800px; max-height: 190vh"
      >
        <button class="btn-close text-dark" @click="closeTermsModal"></button>

        <div class="row py-2 px-0">
          <!-- Second column: Content -->
          <div class="py-2 px-4 card-header">
            <!-- Title Section -->
            <p class="text-start text-md-center text-xs mb-4 pe-5 pe-md-0">
              <strong
                >Términos y Condiciones de Uso y Tratamiento de Datos Personales
                Plataforma Somos PLN</strong
              >
            </p>
            <p class="text-end mb-0 mb-md-2 text-xxs text-md-xs">
              <strong>Última actualización</strong>
            </p>
            <p class="text-end text-xxs text-md-xs">Noviembre 2025</p>
          </div>

          <!-- Terms and Conditions Content -->
          <div
            class="p-4 bg-gray-100 border-radius-lg"
            style="max-height: 400px; overflow-y: auto"
          >
            <div v-if="loadingTerms" class="text-center py-4">
              <div class="spinner-border text-dark" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
              <p class="mt-2">Cargando términos y condiciones...</p>
            </div>

            <div v-else>
              <p><strong>1. Objeto y aceptaci&oacute;n</strong></p>
              <p>
                El presente documento establece los t&eacute;rminos y
                condiciones aplicables al uso del sistema de verificaci&oacute;n
                de electores desarrollado para el Partido Liberaci&oacute;n
                Nacional (PLN), llamado SOMOSPLN, mediante el cual las personas
                usuarias pueden registrar y verificar su informaci&oacute;n de
                contacto (n&uacute;mero de tel&eacute;fono celular y correo
                electr&oacute;nico) asociada a su n&uacute;mero de c&eacute;dula
                de identidad.
              </p>
              <p>
                Al ingresar su n&uacute;mero de c&eacute;dula, proporcionar su
                n&uacute;mero de tel&eacute;fono, recibir un mensaje SMS de
                verificaci&oacute;n y posteriormente ingresar el c&oacute;digo
                recibido, usted declara haber le&iacute;do, comprendido y
                aceptado expresamente estos T&eacute;rminos y Condiciones,
                as&iacute; como autoriza el tratamiento de sus datos personales
                en los t&eacute;rminos aqu&iacute; establecidos.&nbsp;
              </p>
              <p><br /></p>
              <p>
                <strong>2. Responsable del tratamiento de los datos </strong>
              </p>
              <p>
                El Partido Liberaci&oacute;n Nacional, en adelante &apos;el
                responsable&apos;, con domicilio en San Jos&eacute;, Costa Rica,
                es el responsable del tratamiento de los datos personales
                recabados a trav&eacute;s de este sistema.&nbsp;
              </p>
              <p>
                Para consultas relacionadas con el manejo de su
                informaci&oacute;n, podr&aacute; comunicarse al correo
                electr&oacute;nico:
                <a href="mailto:secregeneral@plndigital.com"
                  >secregeneral@plndigital.com</a
                >
                o al tel&eacute;fono indicado en el sitio web oficial del
                Partido.&nbsp;
              </p>
              <p>
                <strong
                  >3. Finalidad del tratamiento de datos personales
                </strong>
              </p>
              <p>
                Los datos personales solicitados (n&uacute;mero de
                c&eacute;dula, n&uacute;mero de tel&eacute;fono y correo
                electr&oacute;nico) ser&aacute;n utilizados &uacute;nicamente
                para los siguientes fines:&nbsp;
              </p>
              <ol style="list-style-type: lower-alpha">
                <li>
                  Verificar la identidad del elector mediante el env&iacute;o de
                  un c&oacute;digo de verificaci&oacute;n al n&uacute;mero de
                  tel&eacute;fono indicado.&nbsp;
                </li>
                <li>
                  Mantener comunicaci&oacute;n con la persona usuaria a
                  trav&eacute;s de mensajes SMS, WhatsApp, correo
                  electr&oacute;nico o llamadas telef&oacute;nicas,
                  exclusivamente para fines informativos, organizativos y de
                  comunicaci&oacute;n interna relacionados con actividades del
                  Partido Liberaci&oacute;n Nacional.&nbsp;
                </li>
                <li>
                  Administrar y mantener actualizado el registro interno de
                  personas verificadas dentro del sistema.&nbsp;
                </li>
              </ol>
              <p><strong>4. Principios del tratamiento </strong></p>
              <p>
                El tratamiento de los datos personales se realiza conforme a los
                principios establecidos en la Ley N.&deg; 8968, en particular:
                licitud, consentimiento informado, finalidad, proporcionalidad,
                veracidad, seguridad y confidencialidad. En ning&uacute;n caso
                se solicitar&aacute; informaci&oacute;n sensible ni se
                realizar&aacute; un uso distinto al aqu&iacute; indicado.&nbsp;
              </p>
              <p>
                <strong
                  >5. Confidencialidad y resguardo de la
                  informaci&oacute;n</strong
                >
              </p>
              <p>&nbsp;El responsable garantiza que:&nbsp;</p>
              <ol style="list-style-type: lower-alpha">
                <li>
                  Los datos personales ser&aacute;n tratados con estricta
                  confidencialidad y protegidos mediante medidas t&eacute;cnicas
                  y organizativas adecuadas para evitar su p&eacute;rdida,
                  acceso no autorizado o divulgaci&oacute;n indebida.&nbsp;
                </li>
                <li>
                  No se transferir&aacute;, vender&aacute; ni compartir&aacute;
                  la base de datos con terceros, salvo requerimiento expreso de
                  autoridad competente conforme a la ley.
                </li>
                <li>
                  El acceso a la informaci&oacute;n est&aacute; limitado
                  &uacute;nicamente al personal autorizado y a los encargados
                  del mantenimiento t&eacute;cnico del sistema bajo contrato de
                  confidencialidad.
                </li>
              </ol>
              <p><strong>6. Consentimiento expreso&nbsp;</strong></p>
              <p>
                Al ingresar el c&oacute;digo de verificaci&oacute;n recibido por
                SMS, usted otorga su consentimiento libre, informado, expreso e
                inequ&iacute;voco para que el Partido Liberaci&oacute;n Nacional
                trate sus datos personales con las finalidades descritas.
              </p>
              <p>
                Este consentimiento se entender&aacute; otorgado desde el
                momento en que el usuario confirma su verificaci&oacute;n dentro
                del sistema.&nbsp;
              </p>
              <p><strong>7. Derechos del titular de los datos </strong></p>
              <p>
                Conforme a la Ley N.&deg; 8968, usted tiene derecho a:&nbsp;
              </p>
              <ol style="list-style-type: lower-alpha">
                <li>
                  Acceder a sus datos personales almacenados en el
                  sistema.&nbsp;
                </li>
                <li>
                  Rectificar los datos que sean inexactos o incompletos.&nbsp;
                </li>
                <li>
                  Suprimir o cancelar sus datos cuando as&iacute; lo solicite,
                  salvo que exista una obligaci&oacute;n legal que impida su
                  eliminaci&oacute;n.&nbsp;
                </li>
                <li>
                  Revocar el consentimiento otorgado, en cualquier momento,
                  mediante solicitud escrita al correo: info@pln.or.cr.&nbsp;
                </li>
              </ol>
              <p><strong>8. Conservaci&oacute;n de los datos</strong></p>
              <p>
                Los datos personales se conservar&aacute;n &uacute;nicamente
                durante el tiempo necesario para cumplir con las finalidades
                mencionadas o mientras se mantenga vigente el consentimiento del
                usuario.&nbsp;
              </p>
              <p><strong>9. Uso del sistema </strong></p>
              <p>
                El usuario se compromete a proporcionar informaci&oacute;n veraz
                y actualizada. Cualquier uso indebido, intento de
                suplantaci&oacute;n o falsificaci&oacute;n de identidad
                ser&aacute; reportado a las autoridades competentes conforme a
                la legislaci&oacute;n costarricense.
              </p>
              <p>
                <strong
                  >10. Modificaciones a los t&eacute;rminos y
                  condiciones</strong
                >
              </p>
              <p>
                El Partido Liberaci&oacute;n Nacional podr&aacute; modificar
                estos t&eacute;rminos en cualquier momento, publicando la
                versi&oacute;n actualizada en su sitio web o sistema de
                verificaci&oacute;n. Dichas modificaciones entrar&aacute;n en
                vigor a partir de su publicaci&oacute;n.&nbsp;
              </p>
              <p>
                <strong
                  >11. Legislaci&oacute;n aplicable y
                  jurisdicci&oacute;n</strong
                >
              </p>
              <p>
                Estos t&eacute;rminos se rigen por las leyes de la
                Rep&uacute;blica de Costa Rica, en particular la Ley N.&deg;
                8968 y su Reglamento. Cualquier controversia relacionada con la
                interpretaci&oacute;n o aplicaci&oacute;n de este documento se
                someter&aacute; a la jurisdicci&oacute;n de los tribunales
                costarricenses.&nbsp;
              </p>
              <p>
                Al ingresar el c&oacute;digo de verificaci&oacute;n recibido por
                SMS, usted manifiesta su aceptaci&oacute;n total de los
                presentes T&eacute;rminos y Condiciones y autoriza expresamente
                el tratamiento de sus datos personales conforme a lo aqu&iacute;
                establecido.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import logoWhite from "@/assets/AppLogo.png";

import ArgonButton from "@/components/ArgonButton.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import { BACK_END_URL } from "@/utilities/config";
import { RECAPTCHA_SITE } from "@/utilities/config";

import { ref, watch, onBeforeMount, onBeforeUnmount, onMounted } from "vue";
import axios from "axios";
import { userInfoStore } from "@/store/userInfoStore";

const errorMessage = ref(""); // General contacto error
const errorMessage2 = ref(""); // Cedula
const errorMessage3 = ref(""); // Terminos
const errorMessagePhone = ref(""); // Telefono
const errorMessageColaboracion = ref(""); // Colaboracion
const errorMessageOtro = ref(""); // Otro texto

const router = useRouter();
const userInfo = userInfoStore();

// Variables
const cedula = ref("");
const selectedOption = ref("");
const otherText = ref("");
const suggestions = ref([]);
const alreadyRegistered = ref(false);
const editedUser = ref(null);
const showDropdown = ref(false);
const nextSection = ref(null);
const nextSection2 = ref(null);
const store = useStore();
const selectedBadge = ref(null);
const isCedulaFilled = ref(false);
const onlyShowNavBar = () => store.commit("onlyShowNavBar");
const isTermsModalOpen = ref(false);
const contactMethod = ref(""); // Guarda "phone" o "email"
const phone = ref("");
const email = ref("");
const toggleDefaultLayout = () => store.commit("toggleDefaultLayout");
const loadingTerms = ref(false);
const termsContent = ref("");
const termsError = ref(false);

const openTermsModal = () => {
  isTermsModalOpen.value = true;
};

const closeTermsModal = () => {
  isTermsModalOpen.value = false;
};

// Obtiene match sugesrencias para cedula
const fetchSuggestions = async () => {
  if (cedula.value.length < 9) {
    suggestions.value = [];
    showDropdown.value = false;
    return;
  }

  try {
    const response = await axios.get(
      `${BACK_END_URL}/analytics/search-by-id/${cedula.value}`
    );
    alreadyRegistered.value = response.data.registradoPorId ? true : false;

    suggestions.value = response.data ? [response.data] : [];
    showDropdown.value = suggestions.value.length > 0;
  } catch (error) {
    console.error("Error fetching suggestions:", error);
    suggestions.value = [];
    showDropdown.value = false;
  }
};

/*
onMounted(() => {
  store.commit("navbarMinimize");
});


onBeforeMount(() => {
  store.dispatch("setConfigButtonVisibility", true);
  store.commit("navbarMinimize");
  const userRole = sessionStorage.getItem("usuarioRol");
  if (!userRole) {
    toggleDefaultLayout(); //Elimina navbar/sidebar
  } else if (userRole === "usuario") {
    onlyShowNavBar(); //Elimina sidebar y footer
  }
});*/

onBeforeUnmount(() => {
  store.dispatch("setConfigButtonVisibility", false);
  //toggleDefaultLayout(); //Elimina navbar/sidebar
});

// Autocompleta informacion segun la cedula
const selectUser = (user) => {
  if (!user || !user.cedula) {
    return;
  }
  isCedulaFilled.value = true;
  editedUser.value = user;
  cedula.value = user.cedula.toString();
  showDropdown.value = false;
  nextSection.value?.scrollIntoView({ behavior: "smooth" });
};

//Control de dropdown de cedula
watch(cedula, (newVal) => {
  // Limita  solo numeros
  cedula.value = newVal.replace(/\D/g, "");
  if (cedula.value.length > 9) {
    cedula.value = cedula.value.slice(0, 9);
  }

  errorMessage2.value = "";

  if (!newVal) {
    editedUser.value = null;
    showDropdown.value = false;
  }
});

// Watch for phone changes to clear error
watch(phone, () => {
  errorMessagePhone.value = "";
  errorMessage.value = "";
});

// Watch for colaboracion changes to clear errors
watch(selectedOption, () => {
  errorMessageColaboracion.value = "";
  errorMessageOtro.value = "";
});

// Watch for other text changes to clear error
watch(otherText, () => {
  errorMessageOtro.value = "";
});

//Seleccionar movimiento
const selectBadge = (badge) => {
  if (isCedulaFilled.value == false) {
    nextSection.value?.scrollIntoView({ behavior: "smooth" });

    errorMessage2.value = "Por favor, ingrese su numero de cedula.";
    return;
  }

  selectedBadge.value = badge;
  nextSection2.value?.scrollIntoView({ behavior: "smooth" }); //Auto scroll
};

const submitSelection = async () => {
  // Reset all error messages
  errorMessage2.value = "";
  errorMessage.value = "";
  errorMessagePhone.value = "";
  errorMessageColaboracion.value = "";
  errorMessageOtro.value = "";
  errorMessage3.value = "";

  let hasErrors = false;

  // Step 1: Cedula validation
  if (!cedula.value || cedula.value.length < 9) {
    errorMessage2.value = "Por favor, ingrese su numero de cedula.";
    nextSection.value?.scrollIntoView({ behavior: "smooth" });
    hasErrors = true;
  }

  // Step 2: Contact validation (phone is required, email is optional)
  if (!phone.value) {
    errorMessagePhone.value = "Por favor, ingrese un número telefónico.";
    hasErrors = true;
  }

  // Step 3: Colaboracion validation
  if (!selectedOption.value) {
    errorMessageColaboracion.value =
      "Por favor, seleccione una opción de colaboración.";
    hasErrors = true;
  } else if (selectedOption.value === "Otro" && !otherText.value.trim()) {
    errorMessageOtro.value = "Por favor, especifique la opción 'Otro'.";
    hasErrors = true;
  }

  if (hasErrors) {
    return;
  }

  try {
    const token = await window.grecaptcha.execute(`${RECAPTCHA_SITE}`, {
      action: "submit",
    });

    // Verify the token with your backend
    const captchaResponse = await axios.post(`${BACK_END_URL}/captcha/verify`, {
      token,
    });

    if (!captchaResponse.data) {
      throw new Error("reCAPTCHA verification failed");
    }

    // Prepare payload
    const payload = {
      //movimiento: selectedBadge.value,
      telefono: phone.value ? parseInt(phone.value, 10) : undefined,
      email: email.value || undefined,
      cedula: cedula.value ? parseInt(cedula.value, 10) : undefined,
      colaboracion:
        selectedOption.value === "Otro"
          ? otherText.value
          : selectedOption.value,
    };

    // Save in pinia
    userInfo.setPayload(payload);

    router.push("/elector/verificacion");
  } catch (error) {
    console.error("Error verifying reCAPTCHA:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Hubo un problema con la verificación. Inténtelo nuevamente.",
    });
  }
};
</script>

<style>
.avatar {
  width: 8% !important;
  height: auto !important;
  margin-left: 1%;
}

.bannerMobile {
  background: linear-gradient(90deg, #186f4c 0%, #2dce89 100%);
  color: #f8f9fa;
  border-radius: 1rem;
  font-size: 28px;
}

@media (max-width: 768px) {
  .avatar {
    width: 20% !important;
    height: 80px !important;
    margin-top: 12%;
    margin-left: 5%;
    z-index: 915;
  }

  .bannerMobile {
    font-size: 18px;
    width: 100%;
    height: 60px;
    margin-bottom: 7%;
  }
}

.form-row {
  --bs-gutter-x: none !important;
}

input.form-control {
  background-color: transparent;
  border: 0cm;
  border-bottom: 1.7px solid #4b4b4b;
  font-size: small;
  margin: 0%;
  font-weight: 600;
  padding-left: 6px;
  padding-top: 3px;
  padding-bottom: 3px;
}

input.form-control:focus {
  border-bottom: 4px solid #adc951;
}

input.form-control.form-control-lg {
  border: 1.7px solid #4b4b4b;
  padding: 0.75rem 2rem;
  width: 80%;
  border-radius: 0.5rem;
  --bs-gutter-x: none;
}

.list-group-item:first-child {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}

.list-group-item:last-child {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}

.parent-container {
  display: flex;
  align-items: center;
  /* Centers vertically */
  justify-content: center;
}

@media (max-width: 768px) {
  .parent-container {
    justify-content: start;
  }
}

.timeline-step {
  background-color: #344767 !important;
  width: 30px !important;
  height: 30px !important;
}

.timeline-step.large {
  background-color: #3d476700 !important;
}

.timeline-step.large i {
  font-size: 25px;
  /* Adjust icon size */
  padding-top: 10px;
}

.timeline-one-side.large:before {
  content: none !important;
}

.dropdown-menu {
  width: 90%;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
  background: white;
  border: 1px solid #ccc;
  padding: 5px;
}

.dropdown-item {
  cursor: pointer;
  padding: 5px;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.selected-badge {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.301) !important;
  /* Soft shadow */
  transition: filter 0.5s ease;
  /* Smooth transition for effect */
  filter: saturate(3);
  /* Increase saturation for selected badge */
  color: #005e4b !important;
}

.badge-hover:not(.selected-badge) {
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

@keyframes breathing {
  0% {
    transform: scale(1.05);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1.05);
  }
}

.selected-badge {
  animation: breathing 3.5s ease-in-out infinite;
}

@keyframes breathing2 {
  0% {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1.2);
  }
}

.requiered {
  animation: breathing2 1s ease-in-out infinite;
}

.modal-backdrop {
  opacity: 0.5;
}

.pdf-preview {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
